
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.667 4.083V1.75m4.666 2.333V1.75m-5.25 4.375h.292m-.292 2.042h.292M7 6.125h.292m2.625 0h.291M7 8.167h.292m2.625 0h.291m-.291 1.75h.291M7 9.917h.292m-3.209 0h.292M2.917 12.25h8.166c.645 0 1.167-.522 1.167-1.167v-7c0-.644-.522-1.166-1.167-1.166H2.917c-.645 0-1.167.522-1.167 1.166v7c0 .645.522 1.167 1.167 1.167z","stroke":"#349BFB","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    